import { isClient } from "@/lib/common";

export function getUrlParameterByName(name: string, url?: string): string | null {
    if (!name) {
        return null;
    }

    if (!url) {
        url = window.location.href;
    }

    name = name.replace(/\[|\]/g, "\\$&");

    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`, "i");
    const results = regex.exec(url);

    if (!results) {
        return null;
    }

    if (!results[2]) {
        return "";
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function getUrlLeftPart(url?: string) {
    if (!url) {
        if (!isClient) {
            return "";
        }

        url = window.location.href;
    }

    const queryIndex = url.indexOf("?");

    return queryIndex > -1 ? url.substring(0, queryIndex) : url;
}
